import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import moment from 'moment';
import {AgendaEvent} from '../../../../../domain/agenda/model/agenda-event';
import {LinkTypeEnum} from '../../../../../domain/agenda/model/link-type.enum';
import {CreateEventDialogComponent} from '../dialog-create/create-event-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {AgendaEventService} from '../../../../../domain/agenda/service/agenda-event.service';
import {DeleteEventDialogComponent} from '../dialog-create/delete-event-dialog/delete-event-dialog.component';
import {EventThemeEnum} from '../../../../../domain/agenda/model/constante/event-theme-enum';
import {AnalyticsCategory} from '../../../../../application/analytics/analytics-category';
import {AnalyticsEventType} from '../../../../../application/analytics/analytics-event-type';
import {AmplitudeService} from '../../../../../application/analytics/service/amplitude.service';
import {AgendaSubjectEventService} from '../../../../../domain/agenda/service/agenda-subject-event.service';

@Component({
             selector: 'app-event',
             templateUrl: './home-news-agenda-event.component.html',
             styleUrls: ['./home-news-agenda-event.component.scss']
           })
export class HomeNewsAgendaEventComponent implements OnInit {

  @Input() eventDate: Date;
  @Input() events: Array<AgendaEvent>;
  @Input() locale: string;
  @Input() isBackOffice: boolean;

  @Output() updateEvent: EventEmitter<void> = new EventEmitter<void>();

  readonly linkTypeEnum = LinkTypeEnum;

  month: string;
  day: string;

  constructor(public dialog: MatDialog,
              private agendaSubjectEvent: AgendaSubjectEventService,
              private agendaEventService: AgendaEventService,
              private amplitudeService: AmplitudeService) {
  }

  ngOnInit(): void {
    this.provideLocaleDateFormat();
  }

  public openEditEventDialog(event: AgendaEvent): void {
    const dialogRef = this.dialog.open(CreateEventDialogComponent, {
      width: '1000px',
      height: '434px',
      data: {
        event
      }
    });

    dialogRef.afterClosed().subscribe(() => this.updateEvent.emit());
  }

  public gotToProgram(event: AgendaEvent): void {
    this.trackAgendaEvent(event, false);
    if (this.hasLinkByType(event, this.linkTypeEnum.PROGRAM_LINK)) {
      window.location.href = this.getLinkByType(event, this.linkTypeEnum.PROGRAM_LINK);
    }
  }

  public onOpenDeleteContact(event: AgendaEvent): void {
    const dialogRef = this.dialog.open(DeleteEventDialogComponent, {
      data: {
        event
      },
      minWidth: '50vw'
    });

    dialogRef.componentInstance.deleteEvent
             .subscribe((eventToDelete: AgendaEvent) => {
               this.deleteEvent(eventToDelete);
             });
  }

  public deleteEvent(event: AgendaEvent): void {
    this.agendaEventService.deleteAgendaElement(event.id).subscribe(() => {
      this.agendaSubjectEvent.onChangeEvents.next();
      this.updateEvent.emit();
    });
  }

  public onRedirectToEvent(event: AgendaEvent, isSubscribe: boolean): void {
    this.trackAgendaEvent(event, isSubscribe);
  }

  private trackAgendaEvent(event: AgendaEvent, isSubscribe: boolean): void {
    const eventProperties = new Map<string, string>();
    eventProperties.set('Categorie', event.category);
    eventProperties.set('Titre', event.title);
    eventProperties.set('Theme', event.theme);
    eventProperties.set('Action', isSubscribe ? 'Inscription' : 'Lecture');
    eventProperties.set('Important', event.focus ? 'Oui' : 'Non');
    this.amplitudeService.trackEventAction(AnalyticsCategory.rightPanel, AnalyticsEventType.events, eventProperties);
  }

  private provideLocaleDateFormat(): void {
    const monthLowerCase = moment(this.eventDate).locale(this.locale)
                                                 .format('MMM')
                                                 .split('', 3)
                                                 .join('');

    this.month = `${monthLowerCase.charAt(0).toUpperCase().concat(monthLowerCase.slice(1))}`;

    this.day = moment(this.eventDate).locale(this.locale)
                                     .format('D');
  }

  public hasLinkByType(event: AgendaEvent, linkType: LinkTypeEnum): boolean {
    return event.links.filter(link => link.typeLink === linkType).length > 0;
  }

  public getLinkByType(event: AgendaEvent, linkType: LinkTypeEnum): string {
    return event.links.filter(link => link.typeLink === linkType).shift().link;
  }

  getClassByTheme(event: AgendaEvent): string {
    switch (event.theme) {
      case EventThemeEnum.DEBT:
        return 'border-dette';
      case EventThemeEnum.PROSPECTIVE:
        return 'border-prospective';
      case EventThemeEnum.GUARANTY:
        return 'border-garantie';
      default :
        return undefined;
    }
  }

  getColorByTheme(event: AgendaEvent): string {
    switch (event.theme) {
      case EventThemeEnum.DEBT:
        return 'insito';
      case EventThemeEnum.PROSPECTIVE:
        return 'prospective-background';
      case EventThemeEnum.GUARANTY:
        return 'violet';
      case EventThemeEnum.SUBSIDIES:
        return 'fairways';
      default :
        return 'secondary';
    }
  }
}
